import { cn } from '@sohanemon/utils';
import { Motion } from '@sohanscript/ui/motion';
import type { ComponentProps } from 'react';

export function Skeleton({
	className,
	layoutId,
	...props
}: ComponentProps<typeof Motion>) {
	return (
		<Motion
			feature="domMax"
			className={cn(
				'animate-pulse motion-reduce:animate-none overflow-hidden rounded-md bg-primary/10',
				className,
			)}
			layoutId={layoutId}
			{...props}
		>
			<Motion
				animate={{ x: '100%' }}
				className="h-full bg-linear-to-r from-transparent via-foreground/10 to-transparent"
				initial={{ x: '-100%' }}
				transition={{
					duration: 1.5,
					repeat: Number.POSITIVE_INFINITY,
					repeatType: 'loop',
				}}
			/>
		</Motion>
	);
}
